<template>
    <div>
    <div class="loading" v-if="loading">
        <mo-loader :loading="loading"></mo-loader>
      </div>
    <div v-if="stateImport == 0">
     <ba-search-card legend="Backup CNIT" v-if="backupDate != null && backupDate != 0 && stateBTValidation">
     <div style="margin: 20px;">Date de la dernière Backup : {{textDate}}</div>
     <ab-icon   @click.native="popupInfoImport" class="cursor-pointer mr14 positionIcon" icon="info"></ab-icon>
     <form @submit.prevent="popupBackupRevert"   style="margin: 20px;" enctype="multipart/form-data">
              <div class="buttons-container flex flex-end">
                <ba-button class="primary" :disabled="stateBTBackup">Restaurer la backup</ba-button>
              </div>
          </form>
     </ba-search-card>
      <ba-search-card legend="Import CSV" v-if="stateBTValidation" style="margin-top:20px;">

              <div class="tooltip-container">
                  <div class="filter-link">
                    <a v-bind:href="handleGetFileExemple(1)">
                      <ab-icon icon="excel"></ab-icon>
                      <div class="txt_logo_excel">
                        Ajout de CNIT (add).csv
                      </div>                      
                    </a>
                  </div>

                  <div class="filter-link">
                    <a v-bind:href="handleGetFileExemple(2)">
                      <ab-icon icon="excel"></ab-icon>
                      <div class="txt_logo_excel">
                         Mise à jour de CNIT (updatecnit).csv
                      </div>                      
                    </a>
                  </div>

                  <div class="filter-link">
                    <a v-bind:href="handleGetFileExemple(3)">
                      <ab-icon icon="excel"></ab-icon>
                      <div class="txt_logo_excel">
                        Mise à jour de fiches articles (updatefiche).csv
                      </div>
                    </a>
                  </div>

                  <div class="filter-link">
                    <a v-bind:href="handleGetFileExemple(4)">
                      <ab-icon icon="excel"></ab-icon>
                      <div class="txt_logo_excel">
                        Suppression de CNIT (delete).csv
                      </div>     
                    </a>                  
                  </div>
              </div>

     
       <form @submit.prevent="uploadFile"   style="margin: 20px;" enctype="multipart/form-data">
               
                <file-pond
                  name="test"
                  ref="pond"
                  :label-idle="attachedFile.pondLabel"
                  :allow-multiple="false"
                  :max-file-size="attachedFile.maxFileSizeTrunc"
                  :label-file-type-not-allowed="'Fichier invalide'"
                  :file-validate-type-label-expected-types="''"
                  :label-max-file-size-exceeded="'Le fichier est trop lourd'"
                  :label-max-file-size="`La taille d'un fichier doit être de ${attachedFile.maxFileSizeTrunc} maximum`"
                  :allow-file-type-validation="true"
                  :fileValidateTypeDetectType="getCustomMIMEType"
                  accepted-file-types="text/csv">
                </file-pond>
                 <div class="buttons-container flex flex-end">
                <ba-button class="primary" :disabled="stateBTImport">Importer</ba-button>
              </div>
              </form>
      </ba-search-card>
<!--      <ba-search-card v-if="result" legend="Etat de l'import CSV">
       
            <div style="margin: 20px;" v-for="(info, index) in result">
                <div v-if="info.type == 'error'">
                    {{ $t('error.errorImportCSV') }} {{info.row}}  , {{info.error}}
                </div> 
            </div>
         
              <div class="buttons-container flex flex-end" style="margin: 20px;">
              <ba-button class="primary"   @click.native="cancelValidation" :disabled="stateBTValidation" >annuler</ba-button>
                <ba-button class="primary" @click.native="popupValidation" :disabled="stateBTValidation" >Valider</ba-button>
              </div>
               
     
      
      </ba-search-card>-->

<!--      <div class="loading" v-if="loading">
        <mo-loader :loading="loading"></mo-loader>
      </div>-->
    
        

    
          </div>
          <div v-if="stateImport == 1">
            <ba-search-card legend="Etat de l'import">
            <div style="margin:20px;">
                Un import est en cours, il n'est pas possible d'effectuer un autre import en meme temps
            </div>
            </ba-search-card>
          </div>
          <div v-if="stateImport == 3">
            <ba-search-card legend="Etat de l'import CSV">
                <div v-if="loadingUploadFile" style="margin: 0px 20px 20px 20px;">
                    <div>Envoi du fichier CSV et contrôle de son contenu...</div>
                    <div class="loading" >
                     <mo-loader :loading="loadingUploadFile"></mo-loader>
                     </div>
                </div>
                <div v-else>
                    <div style="margin: 20px;" v-if="result.length == 1">
                        Fichier d'import validé, cliquez sur Suivant pour poursuivre l'import
                    </div>
                    <div v-else style="margin: 20px;" v-for="(info, index) in result">
                                    <div v-if="info.type == 'error'">
                                        {{ $t('error.errorImportCSV') }} {{info.row}}  , {{info.error}}
                                    </div> 
                                    <div v-if="info.type == 'errorFile'">
                                        {{ $t('error.errorImportCSVFormat') }} 
                                    </div> 
                    </div>
                    

                                  <div class="buttons-container flex flex-end" style="margin: 20px;">
                                  <ba-button class="primary"   @click.native="cancelValidation" >{{ $t('action.cancel')}}</ba-button>
                                    <ba-button class="primary" @click.native="popupValidation" :disabled="stateBTValidation" >{{ $t('action.next')}}</ba-button>
                                  </div>
                    </div>
                
          
                 
             
                
            </ba-search-card>
        </div>
          <div v-if="stateImport == 2">
          <ba-search-card legend="Etat de l'import">
                <div v-if="loadingPopupValidation" style="margin: 0px 20px 20px 20px;">
                    <div>Traitements de l'import en cours...</div>
                    <div class="loading" >
                     <mo-loader :loading="loadingPopupValidation"></mo-loader>
                     </div>
                </div>
                <div v-else-if="resultatImport != null" style="margin: 0px 20px 20px 20px;">
                    <div>Résultat de l'import :</div>
                    <div  style="margin: 20px;" v-for="(info, index) in resultatImport.data">
                        <div>
                             Action : {{$t('text.import'+info.type)}}  | nombre de traitements :{{info.info}}
                        </div> 
                    </div>
                     <div style="padding-top:20px;">Erreur de l'import(s) :</div>
                    <div  style="margin: 20px;" v-for="(info, index) in resultatImport.error">
                        <div style="color:red">
                             {{ $t('error.errorImportCSV') }} {{info.row}}  , {{info.error}}
                        </div> 
                    </div>
                   
                    <div class="buttons-container flex flex-end" style="margin: 20px;">
                            <ba-button class="primary"   @click.native="cancelValidation">Terminer</ba-button>
                            </div>
                </div>
                
            </ba-search-card>
           
            </div>
          
          <modal class="modal" name="popupBackup" width="376px">
            <ba-card>
              <template slot="header">
                <span>{{ $t('sectionTitle.revertBackupFA') }}</span>
              </template>
              <template>
                <p >{{ $t('modal.revertBackupFA') }} </p>
              </template>
              <template slot="footer">
                <div class="buttons-container flex flex-end">
                  <ba-button class="primary" @click.native="closeModalBackup">{{ $t('action.cancel') }}</ba-button>
                  <ba-button class="primary" @click.native="backupRevert">{{ $t('action.confirm') }}</ba-button>
                </div>
              </template>
            </ba-card>
            </modal>
            <modal class="modal" name="popupValide" width="376px">
            <ba-card>
              <template slot="header">
                <span>{{ $t('sectionTitle.validationImport') }}</span>
              </template>
              <template>
             
                <p>{{ $t('modal.validationImport') }} </p>
              </template>
              <template slot="footer">
               
                <div class="buttons-container flex flex-end"  v-if="!loadingPopupValidation">
                  <ba-button class="primary" @click.native="closeModalValidation">{{ $t('action.cancel') }}</ba-button>
                  <ba-button class="primary" @click.native="uploadFileValidation">{{ $t('action.confirm') }}</ba-button>
                </div>
              </template>
            </ba-card>
            </modal>
        
        
        
          <!-- MODAL DETAIL IMPORT -->
            <modal class="modal px-0" name="popupInfoImport" width="653px" height="auto">
            <ba-card>
              <template slot="header">
                <span>{{ $t('sectionTitle.bilan_import_cnit') }}</span>
              </template>
              <template>
                <div class="left car-client-container mb-0 flex-stretch flex-space">
                
                  <div style="width:100%;margin: 0px 20px 0px 20px" v-if="resultatImportOld != null">
                    <div>Résultat de l'import :</div>
                    <div  style="margin: 20px;" v-for="(info, index) in resultatImportOld.data">
                        <div>
                             Action : {{$t('text.import'+info.type)}}  | nombre de traitements :{{info.info}}
                        </div> 
                    </div>
                    <div style="max-height:300px;overflow: auto">
                     <div style="padding-top:20px;">Erreur de l'import(s) :</div>
                    <div  style="margin: 20px;" v-for="(info, index) in resultatImportOld.error">
                        <div style="color:red">
                             {{ $t('error.errorImportCSV') }} {{info.row}}  , {{info.error}}
                        </div> 
                    </div>
                    </div>
                  </div>
                  </div>
              </template>
              <template slot="footer">
                <div class="buttons-container flex flex-end">
                  <ba-button class="primary" @click.native="closeModalInfoImport">{{ $t('action.close') }}</ba-button>
                </div>
              </template>
            </ba-card>
          </modal>
          </div>
          
</template>

<script>
import { mapState } from 'vuex';
import { AbIcon, BaButton, BaCard, BaDropdown, BaInput, BaSearch, BaSearchCard, BaSelect, BaStateLabel, BaTable } from '@ab/basic-components';

import MoLoader from '@/components/loader/mo-loader.vue';
import vueFilePond from 'vue-filepond';
import 'filepond/dist/filepond.min.css';
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';

const FilePond = vueFilePond(FilePondPluginFileValidateSize, FilePondPluginFileValidateType);

import paginationMixin from '@/components/mixins/pagination.js';
import requestMixin from '@/components/mixins/request.js';
import searchMixin from '@/components/mixins/search.js';
import sortableMixin from '@/components/mixins/sortable.js';
import { generateSearchWatcher } from '@/assets/js/helpers.js';

export default {
  name: 'DocumentList-importcsv',
  components: {
    AbIcon,
    BaButton,
    BaCard,
    BaDropdown,
    BaInput,
    BaSearch,
    BaSearchCard,
    BaSelect,
    BaStateLabel,
    BaTable,
    FilePond,
    MoLoader,
  },
  async mounted() {
      this.initInterface();
       

  },
  data() {
    return {
        loadingUploadFile:false,
        loadingPopupValidation:false,
      loading: false,
      stateBTBackup:true,
      stateBTImport:true,
      stateBTValidation:true,
      stateImport:null,
      backupDate:null,
      textDate:null,
      infoBackup:null,
      stateFicheArticle:'general',
      userRole: this.$store.getters.getUserRole,
      result: null,
      isFileUploadOngoing: false,
      infoFile:null,
      attachedFile: {
        fileId: null,
        fileStatus: '',
        maxFileSize: 10000000,
        maxFileSizeTrunc: '10 MB',
        pondLabel: "Glissez votre fichier CSV ou <u>cliquez ici</u>",
        pondAcceptedFileType: [ 'application/vnd.ms-excel','text/csv'],
        currentPage: 1,
        searchLimit: 5,
        resultatImport:null
      },
      resultatImportOld:null
    };
  },
  computed: {

  },
  watch: {
        'attachedFile.fileStatus':function() {
    
    },

        },
  methods: {
      async initInterface() {
            this.loading = true;
       this.infoBackup = await this.$store.dispatch('backupInfo');
       
       this.resultatImportOld = this.infoBackup.rapport;
       this.backupDate = null;
       
       this.stateImport = this.infoBackup.stateImport;
       this.backupDate = this.infoBackup.timeStamp;
       this.textDate = this.infoBackup.date;
       this.stateBTBackup = false;
       this.stateBTImport = false;
        this.loading = false;
      },
      gestionBTState() {
            
      },
      getCustomMIMEType: function getCustomMIMEType(source, type) {
      if (window.navigator.platform.indexOf('Win') > -1) {
        if (type === 'application/vnd.ms-excel') type = 'text/csv'
      }
      return Promise.resolve(type)
    },
    
     async uploadFile() {
        if(!this.stateBTImport) {
            
            // Check if file has been selected
            if (!this.$refs.pond.getFile()) {
              return this.$store.dispatch('displaySnackbar', { text: `Veuillez ajouter un document`, mode: 'error' });
            }

            // Check file type
            const fileType = this.attachedFile.pondAcceptedFileType.find(e => e == this.$refs.pond.getFile().file.type);

            if (typeof fileType == 'undefined') {
              return this.$store.dispatch('displaySnackbar', { text: `Veuillez sélectionner fichier CSV valide`, mode: 'error' });
            }
            this.stateImport = 3;
            this.loadingUploadFile = true;
            this.stateBTImport = true;
            this.stateBTBackup = true;

            let file = this.$refs.pond.getFile().file;
            let formData = new FormData();
            formData.append('fileUpload', file, file.name);

            // Prevent from clicking on button during operation
          //  this.$store.commit('setSpinner', true);

            const data = await this.$store.dispatch('uploadFileCSV', {
              data: formData,
            });
            this.result = data;
             this.infoFile = null;
             this.stateBTValidation = false;
            for(var i in this.result) {
                if(this.result[i].type == "info") {
                    if(this.result[i].fileName != null) {
                        this.infoFile = this.result[i].fileName;
                    }
                }
                else if(this.result[i].type == "errorFile") {
                    this.stateBTValidation = true;
                 }

          }

           // this.$refs.pond.removeFile();
            
        //    this.$store.commit('setSpinner', false);
            this.stateBTImport = false;
            this.stateBTBackup = false;
             this.loadingUploadFile = false;
        }
    },
    
    
    cancelValidation() {
        this.result = null;
        this.stateBTValidation = true;
        this.stateImport = 0;
        this.initInterface();
    },
    
    async uploadFileValidation() {
        if(!this.stateBTValidation) {
            this.closeModalValidation();
            this.stateImport = 2;
            this.loadingPopupValidation = true;
            this.stateBTImport = true;
            this.stateBTBackup = true;
            this.stateBTValidation = true;
                const data = await this.$store.dispatch('validationImportCsv', {
               infoFile: this.infoFile
             });
             this.resultatImport = data;
             this.stateBTImport = false;
            this.stateBTBackup = false;
            this.stateBTValidation = false;
            this.loadingPopupValidation = false;
             
           
            
         }
    },
    
    async backupRevert() {
        if(!this.stateBTBackup) {
            this.stateBTBackup = true;
            const data = await this.$store.dispatch('backupRevertImportcsv', this.backupDate);
            this.backupDate = data.result;
            this.textDate = data.date;
            this.stateBTBackup = false;
            this.closeModalBackup();
             this.initInterface();
           
        }
      },
      
      popupBackupRevert() {
          this.$modal.show('popupBackup');
      },
      closeModalBackup() {
      this.$modal.hide('popupBackup');
    },
    popupValidation() {
          this.$modal.show('popupValide');
      },
    closeModalValidation() {
      this.$modal.hide('popupValide');
    },
    popupInfoImport() {
          this.$modal.show('popupInfoImport');
      },
    closeModalInfoImport() {
      this.$modal.hide('popupInfoImport');
    },
    handleGetFileExemple(x) {
      const baseApi = process.env.VUE_APP_ROOT_API;
      switch (x) {
        case 1:
          return `${baseApi}/public/data/` + encodeURI('Ajout de CNIT (add).csv')
          break
        case 2:
          return `${baseApi}/public/data/` + encodeURI('Mise à jour de CNIT (updatecnit).csv')
          break
        case 3:
          return `${baseApi}/public/data/` + encodeURI('Mise à jour de fiches articles (updatefiche).csv')
          break
        case 4:
          return `${baseApi}/public/data/` + encodeURI('Suppression de CNIT (delete).csv');
          break                    
        default:   
          break         
      }
    }
   
  }
  
};
</script>

<style>
    .positionIcon {
        position:absolute;
        top:60px;
        right:50px;
    }

.tooltip-container {
  display: flex;
}

.filter-link {
  padding-left: 24px;
}

.txt_logo_excel {
  padding-top: 4px;
  float:right;
  font-weight: 400;
  line-height: 1.5;
  color: #4f4f4f;
}
</style>

<style src="@/assets/styles/filepond.css"></style>